import axios from "axios";
import util from "./util";
import config from "../config";

const axiosInstance = axios.create({
    baseURL: config.apiUrl
});

axiosInstance.interceptors.request.use(
    (config) => {
        config.headers.authorization = 'Bearer ' + util.getToken();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        if (response.config?.responseType === "blob" || (typeof Blob !== "undefined" && response.data instanceof Blob)) {
            return { data: response.data, headers: response.headers, success: true };
        }
        if (typeof response.data == typeof String()) {
            return { data: response.data, headers: response.headers };
        }
        return { ...response.data, headers: response.headers };
    },
    async (error) => {
        let response = {};
        const errData = error.response?.data;
        if (typeof Blob !== "undefined" && errData instanceof Blob) {
            try {
                const text = await errData.text();
                response = JSON.parse(text);
            } catch (e) {
                response = { message: error.message || "Download failed" };
            }
        } else if (typeof errData !== "undefined") {
            response = errData;
            if (!response?.message) {
                response.message = error.message;
            }
            if (response.errors && Array.isArray(response.errors)) {
                response.message = response.errors[0].msg;
            }
        } else {
            response.message = error.message;
        }
        return Promise.reject(response);
    }
);

export default axiosInstance;